/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Every_White_Pigeon_QuizInputs */

const fr_every_white_pigeon_quiz = /** @type {(inputs: Every_White_Pigeon_QuizInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Semaine suivante`)
};

/**

* @param {Every_White_Pigeon_QuizInputs} inputs
* @param {{ locale?: "fr" }} options
* @returns {LocalizedString}
*/
export const every_white_pigeon_quiz = /** @type {((inputs?: Every_White_Pigeon_QuizInputs, options?: { locale?: "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Every_White_Pigeon_QuizInputs, { locale?: "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return fr_every_white_pigeon_quiz(inputs)
});